import { supabase } from '../lib/supabase';

export const paymentService = {
  async createPaymentIntent(orderData, customerInfo) {
    try {
      const { data, error } = await supabase?.functions?.invoke('create-payment-intent', {
        body: {
          orderData,
          customerInfo
        }
      });

      if (error) {
        console.error('Edge Function error:', error);
        // Try to extract more details from the error
        const errorMessage = error?.message || 'Unknown error occurred';
        
        // Check if error.context.body is already an object or needs parsing
        let errorDetails = null;
        if (error?.context?.body) {
          if (typeof error?.context?.body === 'string') {
            try {
              errorDetails = JSON.parse(error?.context?.body);
            } catch (parseError) {
              console.error('Failed to parse error body:', parseError);
              errorDetails = { error: error?.context?.body };
            }
          } else if (typeof error?.context?.body === 'object') {
            errorDetails = error?.context?.body;
          }
        }
        
        throw new Error(
          errorDetails?.details || errorDetails?.error || errorMessage
        );
      }
      
      return data;
    } catch (err) {
      console.error('Payment service error:', err);
      throw err;
    }
  },

  async confirmPayment(paymentIntentId) {
    const { data, error } = await supabase?.functions?.invoke('confirm-payment', {
      body: { paymentIntentId }
    });

    if (error) throw error;
    return data;
  },

  formatAmount(amount, currency = 'EUR') {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: currency,
    })?.format(amount);
  }
};